import { Link } from 'lucide-react';

type Props = {
  deviceId: string;
};

export default function DeviceLinkingHeader({ deviceId }: Props) {
  return (
    <div className="flex flex-col gap-2 sm:gap-3 mb-4 sm:mb-6">
      <div className="flex items-center gap-2 sm:gap-3">
        <Link className="w-5 h-5 sm:w-6 sm:h-6 text-green-700 flex-shrink-0" />
        <h2 className="text-xl sm:text-2xl font-bold text-gray-900">
          Link Devices
        </h2>
      </div>
      <p className="text-base text-gray-600">
        Link your devices to access and edit your meeting planners across mobile and
        web.
      </p>
      {deviceId && (
        <p className="text-base text-gray-600">
          Your device ID:{' '}
          <code className="text-xs bg-gray-100 px-2 py-1 rounded break-all">
            {deviceId}
          </code>
        </p>
      )}
    </div>
  );
}

